<template>
  <div class="bg-secondary-3 rounded mb-4 p-3">
    <div class="d-flex justify-content-between align-items-start mb-2">
      <icon-view
        :gradient="false"
        icon="fas fa-paper-plane pr-1 pb-1"
        icon-color="#ff7058"
        icon-size="16px"
        title="Confirmar Envío Masivo"
      />
    </div>
    <div class="d-flex align-items-center mb-3">
      <div class="small text-muted mr-2 text-nowrap">Combinar Batches</div>
      <div class="progress w-100" style="height:8px">
        <div
          class="progress-bar bg-green"
          role="progressbar"
          :style="{ width: progressWidth }"
        />
      </div>
    </div>
    <div class="small  mb-3">
      Combinando {{ batches?.length || 0 }} batches seleccionados en un solo
      envío:
    </div>

    <div v-if="!batches || !batches.length" class="text-muted">
      No hay batches seleccionados.
    </div>

    <div v-else>
      <div
        v-for="(b, idx) in batches"
        :key="b.id || idx"
        class="row d-flex align-items-center py-3 m-1 bg-white rounded"
      >
        <div class="col d-flex align-items-center">
          <div class="mr-2">
            <div class="fas fa-check text-green" />
          </div>
          <div>
            <div class="data-name">Número de Batch:</div>
            <div>
              {{ b.number | empty }}
            </div>
          </div>
        </div>
        <div class="col">
          <div class="data-name">Lugar de Servicio:</div>
          <div>{{ b.location?.name | empty }}</div>
        </div>
        <div class="col">
          <div class="data-name">Cantidad de Reclamaciones:</div>
          <div>{{ b.count | empty }}</div>
        </div>
        <div class="col">
          <div class="data-name">Monto a Reclamar:</div>
          <div>
            {{ b.totalAmount | price }}
          </div>
        </div>
      </div>
      <div class="row my-2 m-1">
        <div class="col" />
        <div class="col" />
        <div class="col">
          <div class="data-name">Cantidad de Reclamaciones:</div>
          <div>{{ totalCount | empty }}</div>
        </div>
        <div class="col">
          <div class="data-name">Monto a Reclamar:</div>
          <div class="font-weight-bold text-success">
            {{ totalAmount | price }}
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-end mt-3">
      <action-button
        i="fas fa-times-circle"
        text="Cancelar"
        variant="outline-danger mr-3"
        @click="$emit('cancel')"
      />
      <action-button
        iright="fas fa-chevron-circle-right"
        text="Continuar"
        variant="success"
        @click="$emit('confirm')"
      />
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import IconView from 'icon-view';

export default {
  name: 'BatchMassSend',
  components: { ActionButton, IconView },
  props: {
    batches: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    totalCount() {
      return this.batches.reduce((s, b) => s + (b.count ?? 0), 0);
    },
    totalAmount() {
      return this.batches.reduce((s, b) => s + (b.totalAmount ?? 0), 0);
    },
    progressWidth() {
      const pct = Math.min(100, (this.batches?.length || 0) * 33);
      return pct + '%';
    },
  },
  methods: {
    formatAmount(val) {
      try {
        const n = Number(val) || 0;
        return n.toLocaleString(undefined, {
          style: 'currency',
          currency: 'USD',
        });
      } catch (e) {
        return val;
      }
    },
  },
};
</script>

<style scoped>
.progress {
  background-color: #f1f3f2;
}
.progress-bar {
  height: 8px;
}
.text-nowrap {
  white-space: nowrap;
}
</style>
